import { cx } from '../lib/cx';

export interface SwitchProps {
  id: string;
  checked: boolean;
  onCheckedChange: (v: boolean) => void;
  label: string;
  description?: string;
  disabled?: boolean;
}

export function Switch({
  id,
  checked,
  onCheckedChange,
  label,
  description,
  disabled,
}: SwitchProps) {
  return (
    <div className="flex items-center justify-between gap-4">
      <span className="flex flex-col">
        <label htmlFor={id} className="text-[14.5px] text-ink">
          {label}
        </label>
        {description && <span className="text-[12px] text-ink-muted">{description}</span>}
      </span>
      <button
        id={id}
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={label}
        disabled={disabled}
        onClick={() => onCheckedChange(!checked)}
        className={cx(
          'relative h-6 w-11 shrink-0 rounded-pill transition-colors duration-200',
          // Ugasen prekidac je blijeda ploha; bez vidljivog ruba se stapa s karticom.
          checked ? 'bg-accent' : 'bg-bg-alt border border-line-control',
          disabled && 'opacity-40 pointer-events-none',
        )}
      >
        <span
          className={cx(
            'absolute top-1/2 h-[18px] w-[18px] -translate-y-1/2 rounded-full bg-surface shadow-card',
            'transition-[left] duration-200',
            checked ? 'left-[23px]' : 'left-[3px]',
          )}
        />
      </button>
    </div>
  );
}
